module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.buyOrder) ? _c('div', [_c('section', {
    staticClass: "content"
  }, [(_vm.buyOrder) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('el-badge', {
    attrs: {
      "value": _vm.getBuyOrderStatusName(_vm.buyOrder.statusId),
      "type": "info"
    }
  }, [(_vm.buyOrder.nic) ? _c('span', {
    staticStyle: {
      "text-align": "left",
      "position": "relative"
    },
    style: ([_vm.buyOrder.history ? {
      'color': '#4370b7',
      'cursor': 'pointer'
    } : {}])
  }, [_c('font', {
    attrs: {
      "size": "6"
    }
  }, [_vm._v("OC: " + _vm._s(_vm.buyOrder.nic))])], 1) : _vm._e()]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "display": "inline-block",
      "float": "right",
      "transition": "all 1s"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-left"
  }), _vm._v("\n                  Volver\n                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "position": "relative"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Razón Social")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buyOrder.company))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Fecha de Liberación")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buyOrder.fecha_liberacion))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("OC (PDF)")]), _vm._v(" "), (_vm.buyOrder.pdf) ? _c('td', [_c('a', {
    attrs: {
      "href": _vm.buyOrder.pdf,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v("  Ver")])]) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && !_vm.buyOrder.pdf) ? _c('td', [_c('input', {
    ref: "fileBuyOrder",
    staticClass: "form-control-file",
    staticStyle: {
      "width": "80%",
      "float": "left"
    },
    attrs: {
      "type": "file",
      "accept": "application/pdf"
    },
    on: {
      "change": _vm.handleFileChange
    }
  }), _vm._v(" "), (_vm.showUpload) ? _c('el-button', {
    staticStyle: {
      "margin-left": "6%"
    },
    attrs: {
      "type": "primary",
      "circle": "",
      "icon": "el-icon-upload"
    },
    on: {
      "click": _vm.uploadBuyOrder
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (!_vm.user.isProvider && _vm.buyOrder.statusId === '2' || _vm.buyOrder.statusId === '9' || _vm.buyOrder.statusId === '3') ? _c('tr', [_c('th', [_vm._v("Cargar código de Operación")]), _vm._v(" "), _c('td', [_c('upload-order', {
    attrs: {
      "idBuyOrder": _vm.buyOrder.idBuyOrder
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && _vm.buyOrder.statusId === '1') ? _c('tr', [_c('th'), _vm._v(" "), _c('td', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.activarBuyOrder()
      }
    }
  }, [_vm._v("Activar "), _c('i', {
    staticClass: "el-icon-check"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.rechazarBuyOrder()
      }
    }
  }, [_vm._v("Rechazar "), _c('i', {
    staticClass: "el-icon-close"
  })])], 1)]) : _vm._e(), _vm._v(" "), (_vm.buyOrder.hes.length > 0) ? _c('tr', [_c('th', [_vm._v("HES Asociada")]), _vm._v(" "), _c('td', _vm._l((_vm.buyOrder.hes), function(value) {
    return _c('ul', {
      key: value.idHes
    }, [(value.number !== '0' && value.type === 'HES') ? [_vm._v("\n                              " + _vm._s(value.number) + " -\n                              " + _vm._s(value.description) + "\n                            ")] : void 0], 2)
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.buyOrder.hes.length > 0) ? _c('tr', [_c('th', [_vm._v("MIGO Asociada")]), _vm._v(" "), _c('td', _vm._l((_vm.buyOrder.hes), function(value) {
    return _c('ul', {
      key: value.idMigo
    }, [(value.number !== '0' && value.type === 'MIGO') ? [_vm._v("\n                              " + _vm._s(value.number) + " -\n                              " + _vm._s(value.description) + "\n                              ")] : void 0], 2)
  }), 0)]) : _vm._e()])])])]), _vm._v(" "), (_vm.buyOrder.documents && _vm.buyOrder.statusId >= '3') ? _c('div', [_c('h2', [_vm._v(" Documentos (Facturas, NC, ND) ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-right": "15px",
      "margin": "10px"
    },
    attrs: {
      "xs": 8,
      "sm": 6,
      "md": 4
    }
  }, [_c('upload-receipt', {
    attrs: {
      "idCompany": _vm.buyOrder.idCompany,
      "idBuyOrder": _vm.buyOrder.idBuyOrder,
      "loadOperationType": false
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Tipo de documento",
      "multiple": ""
    },
    model: {
      value: (_vm.filters[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[0], "value", $$v)
      },
      expression: "filters[0].value"
    }
  }, _vm._l((_vm.buyOrderDocumentType), function(item) {
    return _c('el-option', {
      key: item.buyOrderDocumentType,
      attrs: {
        "value": item.idBuyOrderDocumentType,
        "label": item.description
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Estado",
      "multiple": ""
    },
    model: {
      value: (_vm.filters[1].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[1], "value", $$v)
      },
      expression: "filters[1].value"
    }
  }, _vm._l((_vm.buyOrderDocumentStatus), function(item) {
    return _c('el-option', {
      key: item.idBuyOrderDocumentStatus,
      attrs: {
        "value": item.idBuyOrderDocumentStatus,
        "label": item.description
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('data-tables', {
    attrs: {
      "data": _vm.buyOrder.documents,
      "filters": _vm.filters,
      "pagination-props": {
        pageSizes: [5, 10, 15]
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Tipo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(_vm.getTypeName(scope.row.documentType)) + "\n                    ")]
      }
    }], null, false, 3365448194)
  }), _vm._v(" "), _vm._l((_vm.titleDocument), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom"
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Estado"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(_vm.getStatusName(scope.row.idBuyOrderDocumentStatus)) + "\n                    ")]
      }
    }], null, false, 3181800591)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Código"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.row.number) + "\n                    ")]
      }
    }], null, false, 1543526206)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tipo de código"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.row.type) + "\n                    ")]
      }
    }], null, false, 383852069)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Archivo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.pdf !== '0') ? _c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.pdf,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" PDF\n                      ")]) : _vm._e()]
      }
    }], null, false, 3638233972)
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "-10vh",
      "overflow": "hidden"
    },
    attrs: {
      "title": "Confirmar cambios",
      "visible": _vm.showModalConfirmarDocumentacion,
      "max-width": "700px",
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalConfirmarDocumentacion = $event
      },
      "close": function($event) {
        return _vm.cerrarModalConfirmarDocumentacion()
      }
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": 'Documentos aceptados (' + _vm.documentosAceptados.length + ')'
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.documentosAceptados
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Tipo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                          " + _vm._s(_vm.getTypeName(scope.row.documentType)) + "\n                        ")]
      }
    }], null, false, 2897878530)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "date",
      "label": "Fecha"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Archivo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.pdf,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" PDF\n                          ")])]
      }
    }], null, false, 2690731464)
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": 'Documentos rechazados (' + _vm.documentosRechazados.length + ')'
    }
  }, [_c('el-table', {
    staticStyle: {
      "max-height": "calc("
    },
    attrs: {
      "data": _vm.documentosRechazados
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Tipo",
      "width": "130px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                          " + _vm._s(_vm.getTypeName(scope.row.documentType)) + "\n                        ")]
      }
    }], null, false, 2897878530)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "date",
      "label": "Fecha",
      "width": "200px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Archivo",
      "width": "90px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.pdf,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" PDF\n                          ")])]
      }
    }], null, false, 2690731464)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Mensaje",
      "span": 12
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "Seleccione un motivo"
          },
          model: {
            value: (scope.row.mensajeRechazo),
            callback: function($$v) {
              _vm.$set(scope.row, "mensajeRechazo", $$v)
            },
            expression: "scope.row.mensajeRechazo"
          }
        }, _vm._l((_vm.rejectReasons), function(reason) {
          return _c('el-option', {
            key: reason.value,
            attrs: {
              "label": reason.value,
              "value": reason.value
            }
          })
        }), 1)]
      }
    }], null, false, 974881842)
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.cerrarModalConfirmarDocumentacion()
      }
    }
  }, [_vm._v("\n                    Cancelar\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.confirmarDocumentos()
      }
    }
  }, [_vm._v("\n                    Guardar\n                  ")])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Precarga de Documento (Factura / ND / NC)",
      "visible": _vm.showModalCreateDocument,
      "width": "90%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalCreateDocument = $event
      },
      "close": function($event) {
        return _vm.resetNuevoDocumento()
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "150px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Fecha Vencimiento",
      "prop": "linea"
    }
  }, [_c('el-date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "Fecha Vencimiento"
    },
    model: {
      value: (_vm.nuevoDocumento.FechaVencimiento),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "FechaVencimiento", $$v)
      },
      expression: "nuevoDocumento.FechaVencimiento"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tipo",
      "prop": "linea"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Tipo de documento",
      "required": ""
    },
    model: {
      value: (_vm.nuevoDocumento.documentType),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "documentType", $$v)
      },
      expression: "nuevoDocumento.documentType"
    }
  }, _vm._l((_vm.buyOrderDocumentType), function(item) {
    return _c('el-option', {
      key: item.idBuyOrderDocumentType,
      attrs: {
        "disabled": (!(item.idBuyOrderDocumentType === '1' || _vm.tieneFacturaAceptada())) && _vm.buyOrder.nic !== null,
        "value": item.idBuyOrderDocumentType,
        "label": item.description
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Código AFIP",
      "required": ""
    },
    model: {
      value: (_vm.nuevoDocumento.documentTypeCode),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "documentTypeCode", $$v)
      },
      expression: "nuevoDocumento.documentTypeCode"
    }
  }, _vm._l((_vm.buyOrderDocumentTypeCode), function(item) {
    return _c('el-option', {
      key: item.idBuyOrderDocumentTypeCode,
      attrs: {
        "value": item.idBuyOrderDocumentTypeCode,
        "label": item.description
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tipo",
      "prop": "Nª"
    }
  }, [_c('el-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "required": "",
      "name": "letra",
      "placeholder": "Letra",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.nuevoDocumento.letra),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "letra", $$v)
      },
      expression: "nuevoDocumento.letra"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "A",
      "value": "A"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "B",
      "value": "B"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "C",
      "value": "C"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "required": "",
      "name": "puntoVenta",
      "placeholder": "Punto de Venta"
    },
    model: {
      value: (_vm.nuevoDocumento.puntoVenta),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "puntoVenta", $$v)
      },
      expression: "nuevoDocumento.puntoVenta"
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "type": "text",
      "required": "",
      "name": "numero",
      "placeholder": "Numero"
    },
    model: {
      value: (_vm.nuevoDocumento.numero),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "numero", $$v)
      },
      expression: "nuevoDocumento.numero"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Moneda"
    }
  }, [_c('el-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "required": "",
      "name": "letra",
      "placeholder": " Moneda",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.nuevoDocumento.moneda),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "moneda", $$v)
      },
      expression: "nuevoDocumento.moneda"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "$",
      "value": "$"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "U$A",
      "value": "U$A"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Tipo de Cambio"
    },
    model: {
      value: (_vm.nuevoDocumento.tipoCambio),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "tipoCambio", $$v)
      },
      expression: "nuevoDocumento.tipoCambio"
    }
  })], 1), _vm._v(" "), (_vm.buyOrder.hes.length > 0) ? [_c('el-form-item', {
    attrs: {
      "label": "Asociar HES"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Seleccionar HES"
    },
    model: {
      value: (_vm.nuevoDocumento.hes),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "hes", $$v)
      },
      expression: "nuevoDocumento.hes"
    }
  }, _vm._l((_vm.buyOrder.hes), function(item) {
    return _c('el-option', {
      key: item.idHes,
      attrs: {
        "label": item.number + '-' + item.description,
        "value": item.idHes
      }
    })
  }), 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.buyOrder.hes.length > 0) ? [_c('el-form-item', {
    attrs: {
      "label": "Asociar MIGO"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Seleccionar Migo"
    },
    model: {
      value: (_vm.nuevoDocumento.migo),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "migo", $$v)
      },
      expression: "nuevoDocumento.migo"
    }
  }, _vm._l((_vm.buyOrder.migo), function(item) {
    return _c('el-option', {
      key: item.idMigo,
      attrs: {
        "label": item.number + '-' + item.description + '- Cantidad: ' + item.quantity,
        "value": item.idMigo
      }
    })
  }), 1)], 1)] : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "PDF"
    }
  }, [_c('input', {
    ref: "fileDocument",
    staticClass: "form-control-file",
    staticStyle: {
      "width": "80%",
      "float": "left"
    },
    attrs: {
      "type": "file",
      "accept": "application/pdf"
    },
    on: {
      "change": _vm.handleFileChange
    }
  })])], 2), _vm._v(" "), _c('el-divider', [_vm._v("Linea")]), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label-width": "0",
      "prop": "linea"
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "align": "center",
      "type": "flex",
      "justify": "center",
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v("\n                      Código\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      Producto/Servicio\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v("\n                      Cant.\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v("\n                      U. Medida\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Prec. Unitario\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v("\n                      % Bon.\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Importe Bon.\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v("\n                      Subtotal\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Alicuota IVA\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Subtotal C/IVA\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.nuevoDocumento.lineas), function(linea, lineaId) {
    return _c('el-row', {
      key: lineaId,
      staticStyle: {
        "text-align": "center",
        "margin-bottom": "15px"
      },
      attrs: {
        "align": "center",
        "type": "flex",
        "justify": "center",
        "gutter": 5
      }
    }, [_c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'linea.' + linea + '.codigo'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "required": "",
        "name": "Codigo",
        "placeholder": "Codigo"
      },
      model: {
        value: (linea.codigo),
        callback: function($$v) {
          _vm.$set(linea, "codigo", $$v)
        },
        expression: "linea.codigo"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'linea.' + linea + '.descripcion'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "required": "",
        "name": "Descripcion",
        "placeholder": "Descripcion"
      },
      model: {
        value: (linea.descripcion),
        callback: function($$v) {
          _vm.$set(linea, "descripcion", $$v)
        },
        expression: "linea.descripcion"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'linea.' + linea + '.cantidad'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "required": "",
        "name": "Cantidad",
        "placeholder": "Cantidad"
      },
      model: {
        value: (linea.cantidad),
        callback: function($$v) {
          _vm.$set(linea, "cantidad", $$v)
        },
        expression: "linea.cantidad"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'linea.' + linea + '.medida'
      }
    }, [_c('el-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "required": "",
        "name": "Medida",
        "placeholder": "Medida",
        "filterable": "",
        "clearable": ""
      },
      model: {
        value: (linea.medida),
        callback: function($$v) {
          _vm.$set(linea, "medida", $$v)
        },
        expression: "linea.medida"
      }
    }, [_c('el-option', {
      attrs: {
        "label": "Unidades",
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "Kilogramos",
        "value": "2"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "Metros",
        "value": "3"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "Otro",
        "value": "4"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'linea.' + linea + '.precio'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "required": "",
        "name": "precio",
        "placeholder": "precio"
      },
      on: {
        "change": function($event) {
          return _vm.updateLinea(linea)
        }
      },
      model: {
        value: (linea.precio),
        callback: function($$v) {
          _vm.$set(linea, "precio", $$v)
        },
        expression: "linea.precio"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'linea.' + linea + '.porBoni'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "required": "",
        "name": "porBoni",
        "placeholder": "% Bonif."
      },
      on: {
        "change": function($event) {
          return _vm.updateLinea(linea)
        }
      },
      model: {
        value: (linea.porBoni),
        callback: function($$v) {
          _vm.$set(linea, "porBoni", $$v)
        },
        expression: "linea.porBoni"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'linea.' + linea + '.importeBoni'
      }
    }, [_vm._v("\n                               " + _vm._s('$' + linea.importeBoni) + "\n                      ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'linea.' + linea + '.subtotal'
      }
    }, [_vm._v("\n                        " + _vm._s('$' + linea.subtotal) + "\n                          \n                      ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'linea.' + linea + '.iva'
      }
    }, [_c('el-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "required": "",
        "name": "Iva",
        "placeholder": "Iva",
        "filterable": "",
        "clearable": ""
      },
      on: {
        "change": function($event) {
          return _vm.updateLinea(linea)
        }
      },
      model: {
        value: (linea.iva),
        callback: function($$v) {
          _vm.$set(linea, "iva", $$v)
        },
        expression: "linea.iva"
      }
    }, [_c('el-option', {
      attrs: {
        "label": "Exento",
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "2,5%",
        "value": "1.025"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "0,5%",
        "value": "1.05"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "21%",
        "value": "1.21"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "27%",
        "value": "1.27"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'linea.' + linea + '.subtotalIva'
      }
    }, [_vm._v("                       \n                     " + _vm._s('$' + linea.subtotalIva) + "\n                      ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('el-button', {
      attrs: {
        "type": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.deleteLinea(linea)
        }
      }
    }, [_vm._v("X")])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "justify": "center"
    },
    on: {
      "click": function($event) {
        return _vm.addLinea()
      }
    }
  }, [_vm._v("Agregar linea")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-divider', [_vm._v("Otros Impuestos")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "0",
      "prop": "impuesto"
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "align": "center",
      "type": "flex",
      "justify": "center",
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      Descripción\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      Detalle\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Base Imponible\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Alicuota %\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Importe\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1), _vm._v(" "), _vm._l((_vm.nuevoDocumento.impuestos), function(impuesto, impuestoId) {
    return _c('el-row', {
      key: impuestoId,
      staticStyle: {
        "text-align": "center",
        "margin-bottom": "15px"
      },
      attrs: {
        "align": "center",
        "type": "flex",
        "justify": "center",
        "gutter": 5
      }
    }, [_c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'impuesto.' + impuesto + '.descripcion'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "required": "",
        "name": "Descripcion",
        "placeholder": "Descripcion"
      },
      model: {
        value: (impuesto.descripcion),
        callback: function($$v) {
          _vm.$set(impuesto, "descripcion", $$v)
        },
        expression: "impuesto.descripcion"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'impuesto.' + impuesto + '.detalle'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "required": "",
        "name": "Detalle",
        "placeholder": "Detalle"
      },
      model: {
        value: (impuesto.detalle),
        callback: function($$v) {
          _vm.$set(impuesto, "detalle", $$v)
        },
        expression: "impuesto.detalle"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'impuesto.' + impuesto + '.baseImponible'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "required": "",
        "name": "baseImponible",
        "placeholder": "Base Imponible"
      },
      on: {
        "change": function($event) {
          return _vm.updateImpuesto(impuesto)
        }
      },
      model: {
        value: (impuesto.baseImponible),
        callback: function($$v) {
          _vm.$set(impuesto, "baseImponible", $$v)
        },
        expression: "impuesto.baseImponible"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'impuesto.' + impuesto + '.alicuota'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "required": "",
        "name": "alicuota",
        "placeholder": "Alicuota"
      },
      on: {
        "change": function($event) {
          return _vm.updateImpuesto(impuesto)
        }
      },
      model: {
        value: (impuesto.alicuota),
        callback: function($$v) {
          _vm.$set(impuesto, "alicuota", $$v)
        },
        expression: "impuesto.alicuota"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'impuesto.' + impuesto + '.importe'
      }
    }, [_vm._v("\n                       " + _vm._s('$' + impuesto.importe) + "\n                      ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('el-button', {
      attrs: {
        "type": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.deleteImpuesto(impuesto)
        }
      }
    }, [_vm._v("X")])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "justify": "center"
    },
    on: {
      "click": function($event) {
        return _vm.addImpuesto()
      }
    }
  }, [_vm._v("Agregar Impuesto")])], 1)], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "0",
      "prop": "linea"
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "align": "center",
      "type": "flex",
      "justify": "center",
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "align": "center",
      "type": "flex",
      "justify": "center",
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Total sin Impuesto\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      " + _vm._s('$' + this.nuevoDocumento.importeTotal) + "\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "align": "center",
      "type": "flex",
      "justify": "center",
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Total con IVA\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      " + _vm._s('$' + this.nuevoDocumento.importeImpuesto) + "\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "align": "center",
      "type": "flex",
      "justify": "center",
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      Total Otros Impuestos\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      " + _vm._s('$' + this.nuevoDocumento.importeOtrosImpuesto) + "\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "align": "center",
      "type": "flex",
      "justify": "center",
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Total con IVA\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      " + _vm._s('$' + this.nuevoDocumento.importeImpuesto) + "\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "align": "center",
      "type": "flex",
      "justify": "center",
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      Total con Impuestos\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      " + _vm._s('$' + this.nuevoDocumento.importeTotalImpuesto) + "\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.hideModal()
      }
    }
  }, [_vm._v("\n                    Cancelar\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.createDocument()
      }
    }
  }, [_vm._v("\n                    Enviar\n                  ")])])], 1), _vm._v(" "), (_vm.buyOrderDocument) ? _c('el-dialog', {
    staticStyle: {
      "margin-top": "-10vh",
      "overflow": "hidden"
    },
    attrs: {
      "title": 'Orden de pago',
      "visible": _vm.showModalPaymentOrder,
      "width": "70%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalPaymentOrder = $event
      },
      "close": function($event) {
        return _vm.resetNewPaymentOrder()
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_vm._v("Orden de Pago / Retenciones")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [(_vm.buyOrderDocument.paymentOrder && _vm.buyOrderDocument.paymentOrder.pdf) ? _c('td', [(_vm.buyOrderDocument.paymentOrder.pdf !== '0') ? _c('a', {
    attrs: {
      "href": _vm.buyOrderDocument.paymentOrder.pdf,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v("  Ver")]) : _c('span', [_vm._v("No se cargo un archivo")])]) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && (!_vm.buyOrderDocument.paymentOrder || !_vm.buyOrderDocument.paymentOrder.pdf)) ? _c('span', [_c('input', {
    ref: "filePayment",
    staticClass: "form-control-file",
    staticStyle: {
      "width": "80%",
      "float": "left"
    },
    attrs: {
      "type": "file",
      "accept": "application/pdf"
    },
    on: {
      "change": _vm.handleFileChange
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_vm._v("Información de Pago")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('td', [(_vm.buyOrderDocument.idBuyOrderDocumentStatus === '4' && _vm.buyOrderDocument.paymentOrder) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.buyOrderDocument.paymentOrder.comment)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.buyOrderDocument.idBuyOrderDocumentStatus === '2' && !_vm.user.isProvider && !_vm.buyOrderDocument.paymentOrder) ? _c('span', [_c('vue-editor', {
    model: {
      value: (_vm.newPaymentOrder.comment),
      callback: function($$v) {
        _vm.$set(_vm.newPaymentOrder, "comment", $$v)
      },
      expression: "newPaymentOrder.comment"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.buyOrderDocument.paymentOrder) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.hideModalPaymentOrder()
      }
    }
  }, [_vm._v("\n                    Cancelar\n                  ")]) : _vm._e(), _vm._v(" "), (!_vm.buyOrderDocument.paymentOrder) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.uploadPayment()
      }
    }
  }, [_vm._v("\n                    Guardar\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.buyOrderDocument.paymentOrder) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.hideModalPaymentOrder()
      }
    }
  }, [_vm._v("\n                    Aceptar\n                  ")]) : _vm._e()])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.buyOrder.historial && !_vm.user.isProvider) ? _c('h2', [_vm._v(" Historial ")]) : _vm._e(), _vm._v(" "), (_vm.buyOrder.historial && !_vm.user.isProvider) ? _c('data-tables', {
    attrs: {
      "data": _vm.buyOrder.historial,
      "pagination-props": {
        pageSizes: [5, 10, 15]
      }
    }
  }, _vm._l(([{
    'prop': 'detalle',
    'label': 'Detalle'
  }, {
    'prop': 'date',
    label: 'Fecha'
  }]), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "default-sort": {
          prop: 'date',
          order: 'ascending'
        },
        "sortable": "custom"
      }
    })
  }), 1) : _vm._e()], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-209df3ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/InvoiceDetail.vue
// module id = 613
// module chunks = 1